import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Header, Segment, Feature, NeuCard, ButtonFA } from 'components';
import { colors } from 'utils/colors';
import { Planning } from 'actions';
import {
  PLANNING_DECUMULATION_OPTIMAL_DRAWDOWN,
  PLANNING_DECUMULATION_OPTIMAL_DRAWDOWN_TARGET_SPENDING,
  PLANNING_DECUMULATION_REVISIT_DRAWDOWN,
  PLANNING_DECUMULATION_PORTFOLIO_LONGEVITY,
  PLANNING_DECUMULATION_RUIN_PROBABILITY,
  PLANNING_DECUMULATION_OPTIMAL_DRAWDOWN_COUPLES,
} from 'utils/features';
import asset4 from 'images/asset_4.png';
import {
  faArrowTrendDown,
  // eslint-disable-next-line import/extensions
} from '@fortawesome/free-solid-svg-icons';

@withRouter
@connect((state) => ({
  account: state.CustomAccount.account,
}))
class Landing extends Component {
  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(Planning.clearStore());
  }

  render() {
    const { history } = this.props;
    return (
      <Segment expand>
        <Feature name={PLANNING_DECUMULATION_REVISIT_DRAWDOWN}>
          <ButtonFA
            className="left"
            color={colors.orange}
            style={{
              backgroundColor: 'white',
              display: 'block',
              marginBottom: '5px',
              position: 'absolute',
              top: '2.5rem',
              right: '3.3rem',
            }}
            icon={faArrowTrendDown}
            onClick={() => {
              history.push(`/planning/drawdown-plans`);
            }}
          >
            See Saved Plans
          </ButtonFA>{' '}
        </Feature>

        <div>
          <img src={asset4} height="80" width="120" alt="Portfolio" />
          <Header size="1.5rem" color="black">
            Decumulation
          </Header>
          <P>
            Here are some simple-to-use tools to help you calculate your target
            wealth at retirement and how much you need to save in order to reach
            a particular goal, such as your children’s education or retirement.
          </P>

          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {' '}
            <Feature name={PLANNING_DECUMULATION_PORTFOLIO_LONGEVITY}>
              <NeuCard
                to="/planning/longevity"
                iconName="road"
                title="Portfolio Longevity"
                description="See how long your savings will last using different investment options versus how long you are expected to live. It is a great tool for understanding longevity risk."
                color={colors.orange}
              />
            </Feature>
            <Feature name={PLANNING_DECUMULATION_RUIN_PROBABILITY}>
              <NeuCard
                to="/planning/ruin-probability"
                iconName="warning sign"
                title="Will You Outlive Your Money?"
                description='This is a popular personal finance concept called the "Probability of Ruin". The difference between this tool and Portfolio Longevity is that the latter only compares the average portfolio lifespan against an expected life expectancy for simplicity.'
                color={colors.orange}
              />
            </Feature>
            <Feature name={PLANNING_DECUMULATION_OPTIMAL_DRAWDOWN}>
              <NeuCard
                to="/planning/drawdown/new"
                iconName="signal"
                title="Optimal Drawdown"
                description="See how much you can afford to spend per year given your
                    actual savings and retirement income, and from which sources
                    (registered and non-registered savings)."
                color={colors.orange}
              />
            </Feature>
            <Feature
              name={PLANNING_DECUMULATION_OPTIMAL_DRAWDOWN_TARGET_SPENDING}
            >
              <NeuCard
                to="/planning/drawdown-target-spending/new"
                iconName="target"
                title="Optimal Drawdown with Target Spending"
                description="You have an annual spending amount in mind. Use this tool to
                    see how to optimally withdraw from your registered and
                    non-registered savings to minimize taxes."
                color={colors.orange}
              />
            </Feature>
            <Feature name={PLANNING_DECUMULATION_OPTIMAL_DRAWDOWN_COUPLES}>
              <NeuCard
                to="/planning/drawdown-couples/new"
                color={colors.orange}
                width="50%"
                iconName="signal"
                title="Optimal Drawdown for Couples"
                description="See if there is a tax advantage to filing your and your spouse/partner's returns as a couple. This tool checks for eligible pension income splitting and credit transfers."
              />
            </Feature>
          </div>
        </div>
      </Segment>
    );
  }
}

export default Landing;

Landing.propTypes = {
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
};

const P = styled.p`
  color: rgba(0, 0, 0, 0.5) !important;
  max-width: 650px;
  margin: 0 auto 3rem auto;

  &.strike {
    text-decoration: line-through;
  }
`;
